import React from "react";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import { NavLink } from "react-router-dom";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import { useData } from "../../context/DataContext";
const useStyles = makeStyles((theme) => {
  return {
    root: {
      width: "calc(100%-20px)",
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
    small: {
      width: theme.spacing(4),
      height: theme.spacing(4),
      fontSize: `0.9rem`,
    },
    main: {
      paddingLeft: theme.spacing(2),
      minWidth: `250px`,
      width: `280px`,
      height: `60px`,
      borderRadius: 20,
      "& *": {
        fontWeight: 400,
      }
    },
    divider: {
      backgroundColor: `rgba(84, 222, 232,0.05)`,
      color: `#53dde8`,
      "&:hover": {
        color: `#53dde8`,
        backgroundColor: `rgba(84, 222, 232,0.2)`,
      },
    },
    icon: {
      color: `inherit`,
    },
    padding: {
      padding: `1.8rem`,
    },
    div:{
      paddingLeft: theme.spacing(2)
    }
  };
});

const SideDrawer = (props) => {
  const classes = useStyles();
  const icons = [1,2,3,4,5]
  const data = useData()
  return (
    <Drawer
      anchor="right"
      open={props.open}
      className={classes.padding}
      onClose={props.onClose}
    >
      <div className={classes.padding}>
      <Typography variant="h4" className="pt-4">
        <img src={data.website_details?.logo?.[0].src} className="h-auto" alt={data.website_details.website_name} style={{width: 200}} />
      </Typography>
      <List component="nav">
        <ListItem
          component={NavLink}
          onClick={props.onClose}
          to="/"
          exact
          activeClassName={classes.divider}
          button
          className={"my_link " + classes.main}
        >
          <ListItemText primary="Home" />
        </ListItem>
        <ListItem
          component={NavLink}
          onClick={props.onClose}
          to="/about"
          exact
          activeClassName={classes.divider}
          button
          className={"my_link " + classes.main}
        >
          <ListItemText primary="About" />
        </ListItem>
        <ListItem
          component={NavLink}
          onClick={props.onClose}
          to="/faq"
          exact
          activeClassName={classes.divider}
          button
          className={"my_link " + classes.main}
        >
          <ListItemText primary="FAQ" />
        </ListItem>
        <ListItem
          component={NavLink}
          onClick={props.onClose}
          to="/terms"
          exact
          activeClassName={classes.divider}
          button
          className={"my_link " + classes.main}
        >
          <ListItemText primary="Terms & Conditions" />
        </ListItem>

        <ListItem
          component={NavLink}
          onClick={props.onClose}
          to="/payment"
          exact
          activeClassName={classes.divider}
          button
          className={"my_link " + classes.main}
        >
          <ListItemText primary="Payment Page" />
        </ListItem>
        <ListItem
          component={NavLink}
          onClick={props.onClose}
          to="/join_us"
          exact
          activeClassName={classes.divider}
          button
          className={"my_link " + classes.main}
        >
          <ListItemText primary="Join Us" />
        </ListItem>
      </List>
      <div className={"social-media-div d-flex justify-content-between "+ classes.div}>
        {icons.map(el=>data[`social_icon_${el}`]).map(el=>(
          <a href={el.link} title={el.icon_name} rel="noreferrer" target="_blank">
            {el.icon?.[0]&&<img
              alt={el.icon_name}
              src={el.icon?.[0].src}
              style={{ width: "28px", height: "28px" }}
            />}
          </a>
        ))}
      </div>
      </div>
    </Drawer>
  );
};

export default SideDrawer;
